{
  "familyId": "REK-CIJF-KEER",
  "questions": [
    {
      "id": "REK-CIJF-KEER-001",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 47 × 6",
      "options": [],
      "correctAnswer": "282",
      "data": {
        "acceptedAnswers": ["282"],
        "operand1": 47,
        "operand2": 6,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend vermenigvuldigen: per cijfer",
            "content": "Begin rechts: 7 × 6 = 42 → schrijf 2, onthoud 4. Dan: 4 × 6 = 24, plus 4 onthouden = 28. Antwoord: 282. Tip: werk altijd van rechts naar links en vergeet het 'onthouden' niet!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_2x1_onthouden",
      "variantIndex": 1,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "47 × 6: begin rechts. Eenheden: 7 × 6 = 42 → schrijf 2, onthoud 4. Tientallen: 4 × 6 = 24, plus 4 onthouden = 28. Antwoord: 282. Werk altijd van rechts naar links en vergeet het 'onthouden' niet.",
        "solutionSteps": [
          "Eenheden: 7 × 6 = 42 → schrijf 2, onthoud 4",
          "Tientallen: 4 × 6 = 24 + 4 = 28",
          "Antwoord: 282"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-002",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 83 × 7",
      "options": ["581", "561", "591", "571"],
      "correctAnswer": 0,
      "data": {
        "operand1": 83,
        "operand2": 7,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap vermenigvuldigen",
            "content": "83 × 7: begin rechts. 3 × 7 = 21 → schrijf 1, onthoud 2. Dan: 8 × 7 = 56, plus 2 onthouden = 58. Antwoord: 581.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_2x1_basis",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "83 × 7: begin rechts. Eenheden: 3 × 7 = 21 → schrijf 1, onthoud 2. Tientallen: 8 × 7 = 56, plus 2 onthouden = 58. Antwoord: 581.",
        "solutionSteps": [
          "Eenheden: 3 × 7 = 21 → schrijf 1, onthoud 2",
          "Tientallen: 8 × 7 = 56 + 2 = 58",
          "Antwoord: 581"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × 7 = 21 (schrijf 1, onthoud 2), 8 × 7 = 56 + 2 = 58. Antwoord: 581.",
          "1": "Je dacht waarschijnlijk 8 × 7 = 56, maar vergat de 2 erbij te tellen die je onthield. 56 + 2 = 58, dus het antwoord is 581, niet 561.",
          "2": "Je dacht waarschijnlijk 3 × 7 = 21, maar schreef 1 op en onthield 3 in plaats van 2. 8 × 7 = 56 + 2 = 58, niet 59. Antwoord: 581.",
          "3": "Je dacht waarschijnlijk 8 × 7 = 57. Maar 8 × 7 = 56, plus 2 onthouden = 58. Antwoord: 581, niet 571."
        }
      }
    },
    {
      "id": "REK-CIJF-KEER-003",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 156 × 4",
      "options": [],
      "correctAnswer": "624",
      "data": {
        "acceptedAnswers": ["624"],
        "operand1": 156,
        "operand2": 4,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Driecijferig × eencijferig",
            "content": "156 × 4: begin rechts. 6 × 4 = 24 → schrijf 4, onthoud 2. 5 × 4 = 20, plus 2 = 22 → schrijf 2, onthoud 2. 1 × 4 = 4, plus 2 = 6. Antwoord: 624.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_3x1_onthouden",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "156 × 4: begin rechts. Eenheden: 6 × 4 = 24 → schrijf 4, onthoud 2. Tientallen: 5 × 4 = 20 + 2 = 22 → schrijf 2, onthoud 2. Honderdtallen: 1 × 4 = 4 + 2 = 6. Antwoord: 624.",
        "solutionSteps": [
          "Eenheden: 6 × 4 = 24 → schrijf 4, onthoud 2",
          "Tientallen: 5 × 4 = 20 + 2 = 22 → schrijf 2, onthoud 2",
          "Honderdtallen: 1 × 4 = 4 + 2 = 6",
          "Antwoord: 624"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-004",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 209 × 3",
      "options": ["627", "607", "637", "927"],
      "correctAnswer": 0,
      "data": {
        "operand1": 209,
        "operand2": 3,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Let op de nul!",
            "content": "209 × 3: begin rechts. 9 × 3 = 27 → schrijf 7, onthoud 2. 0 × 3 = 0, plus 2 = 2. 2 × 3 = 6. Antwoord: 627. Let op: 0 × 3 = 0, maar vergeet het onthouden niet!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_met_nul",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "209 × 3: begin rechts. 9 × 3 = 27 → schrijf 7, onthoud 2. 0 × 3 = 0, plus 2 onthouden = 2. 2 × 3 = 6. Antwoord: 627. De nul in het midden is een veelgemaakte fout — 0 × 3 = 0, maar het onthouden telt wél mee!",
        "solutionSteps": [
          "Eenheden: 9 × 3 = 27 → schrijf 7, onthoud 2",
          "Tientallen: 0 × 3 = 0 + 2 = 2",
          "Honderdtallen: 2 × 3 = 6",
          "Antwoord: 627"
        ],
        "distractorExplanations": {
          "0": "Goed! 9 × 3 = 27 (schrijf 7, onthoud 2), 0 × 3 + 2 = 2, 2 × 3 = 6. Antwoord: 627.",
          "1": "Je vergat het onthouden bij de tientallen. 0 × 3 = 0, maar je had nog 2 onthouden van 27. Dus de tientallen worden 2, niet 0. Antwoord: 627, niet 607.",
          "2": "Je dacht waarschijnlijk 0 × 3 = 0 + 2 = 3 in plaats van 2. Controleer: 9 × 3 = 27, onthoud 2 (niet 3). Antwoord: 627.",
          "3": "Je verwarde 2 × 3 met 3 × 3 = 9. De honderdtallen zijn 2 × 3 = 6, niet 9. Antwoord: 627."
        }
      }
    },
    {
      "id": "REK-CIJF-KEER-005",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Een bakker bakt 8 bakplaten met elk 36 koekjes. Hoeveel koekjes bakt hij in totaal? Reken cijferend uit.",
      "options": ["288", "248", "298", "268"],
      "correctAnswer": 0,
      "data": {
        "operand1": 36,
        "operand2": 8,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend vermenigvuldigen in context",
            "content": "36 × 8: begin rechts. 6 × 8 = 48 → schrijf 8, onthoud 4. 3 × 8 = 24, plus 4 = 28. Antwoord: 288 koekjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_context",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "36 × 8 = 288. Cijferend: 6 × 8 = 48 → schrijf 8, onthoud 4. 3 × 8 = 24 + 4 = 28. De bakker bakt 288 koekjes. Bij contextopgaven: herken eerst welke bewerking je nodig hebt (hier: vermenigvuldigen).",
        "solutionSteps": [
          "Herken: 8 bakplaten × 36 koekjes = 36 × 8",
          "Eenheden: 6 × 8 = 48 → schrijf 8, onthoud 4",
          "Tientallen: 3 × 8 = 24 + 4 = 28",
          "Antwoord: 288 koekjes"
        ],
        "distractorExplanations": {
          "0": "Goed! 36 × 8 = 288 koekjes in totaal.",
          "1": "Je dacht waarschijnlijk 3 × 8 = 24 + 4 = 24 (vergat het onthouden). 3 × 8 = 24, plus 4 onthouden = 28. Antwoord: 288, niet 248.",
          "2": "Je dacht waarschijnlijk 6 × 8 = 48, onthoud 5 (in plaats van 4). 3 × 8 = 24 + 4 = 28, niet 29. Antwoord: 288, niet 298.",
          "3": "Je dacht waarschijnlijk 36 × 8 = 268. Controleer: 6 × 8 = 48 (niet 38). Schrijf 8, onthoud 4. 3 × 8 + 4 = 28. Antwoord: 288."
        }
      }
    }
  ]
}